<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
<!--          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item> -->
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clickSearch" placeholder="请输入合同编号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.customername" @keyup.enter.native="clickSearch" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.projectcode" placeholder="请选择产品" class="select" filterable>
              <el-option
                v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.reviewstatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择审批状态" value="-1"></el-option>
              <el-option label="审核被拒绝" value="0"></el-option>
<!--              <el-option label="待销售审核" value="1"></el-option>
              <el-option label="待财务审核" value="2"></el-option>
              <el-option label="待副总审核" value="3"></el-option> -->
              <el-option label="待总经理审核" value="4"></el-option>
              <el-option label="已审核" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="发货日期(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="发货日期(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.SubProjectlist" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="Projectname" label="产品名称" width="200"></el-table-column>
                <el-table-column prop="Num" label="数量" width="200"></el-table-column>
                <el-table-column prop="Unitprice" label="单价" width="200"></el-table-column>
                <el-table-column prop="Discountrate" label="折扣率" width="200"></el-table-column>
                <el-table-column prop="Shichangjia" label="市场销售价" width="200"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="合同编号" width="160"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型" width="80"></el-table-column>
          <el-table-column prop="IsdingzhiName" label="是否定制" width="80"></el-table-column>
          <el-table-column prop="Salecompany" label="销售单位" width="200"></el-table-column>
          <el-table-column prop="Num" label="订单总数量" width="100"></el-table-column>
          <el-table-column prop="Amountoriginal" label="合同总额" width="100"></el-table-column>
          <el-table-column prop="Amountrebates" label="返利" width="80"></el-table-column>
          <el-table-column prop="Amount" label="订单总金额" width="100"></el-table-column>
          <el-table-column prop="CustomerName" label="客户名称" width="200"></el-table-column>
          <el-table-column prop="SalesmanName" label="销售员" width="100"></el-table-column>
          <el-table-column prop="GendanmanName" label="跟单员" width="100"></el-table-column>
          <el-table-column prop="Sublist" label="收款信息" width="150">
            <template slot-scope="props">
              <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;" @click="cilckSublist(props.row)">点击查看详情</span>
            </template>
          </el-table-column>
          <el-table-column prop="Sendtime" label="发货日期" width="200"></el-table-column>
          <el-table-column prop="Sendaddress" label="发货地址" width="200"></el-table-column>
          <el-table-column prop="ReviewstatusName" label="审核状态" width="150"></el-table-column>
          <el-table-column prop="Opinion" label="审核意见" width="150"></el-table-column>
          <el-table-column prop="Reply" label="答复审核意见" width="150"></el-table-column>
          <el-table-column label="定制文件" width="200">
            <template v-slot="scope">
              <el-button v-for="Dingzhifile in scope.row.Dingzhifiles" type="text" @click="clickfile(Dingzhifile)">定制文件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Beizhu" label="备注" width="200"></el-table-column>
          <el-table-column label="附件" width="200">
            <template v-slot="scope">
              <el-button v-for="Attachment in scope.row.Attachments" type="text" @click="clickfile(Attachment)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Reviewstatus == 0 && useriderp == scope.row.Createuserid" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe0(scope.row)">再次提交审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 1 && SubRule_Erp6SaleOrder_XiaoShou" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,1)">销售审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 2 && SubRule_Erp6SaleOrder_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,2)">财务审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 3 && SubRule_Erp6SaleOrder_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,3)">副总审核</el-button>
              <el-button v-if="scope.row.Reviewstatus == 4 && SubRule_Erp6SaleOrder_Zong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1234(scope.row,4)">总经理审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 审批 start -->
        <el-dialog
          title=""
          :visible.sync="dialogShenPi"
          width="880px">
          <el-form :model="modelShenPi" ref="modelShenPi" label-width="170px">
            <el-form-item label="审批意见(可选)" class="addAdminForm">
              <el-input v-model="modelShenPi.opinion" placeholder="如果拒绝,请填写审批意见"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="ShenHeOK">同意</el-button>
              <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 审批 end -->

        <el-dialog
          title="再次提交审核"
          :visible.sync="dialogSubmitAgain"
          width="35%">
          <el-form :model="modelSubmitAgain" ref="modelSubmitAgain" label-width="170px">
            <el-form-item label="答复审批意见" class="addAdminForm">
              <el-input v-model="modelSubmitAgain.reply" placeholder="请填写答复"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="SubmitAgain">提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加销售订单" name="three">
      <el-form :model="addForm" ref="addForm" label-width="170px">
        <el-form-item class="addAdminForm" label="销售类型">
          <el-select v-model="addForm.saletype" placeholder="请选择">
            <el-option label="直销" value="1"></el-option>
            <el-option label="贴牌" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="是否定制" v-if="addForm.saletype==2">
          <el-select v-model="addForm.isdingzhi" placeholder="请选择">
            <el-option label="不定制" value="1"></el-option>
            <el-option label="定制" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm" label="销售单位">
          <el-select v-model="addForm.salecompany" placeholder="请选择">
            <el-option
              v-for="item in PurchaseCompanyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="产品名称">
          <div class="productdata1">
            <div class="productdata2">
              <el-select v-model="addForm.projectcode" placeholder="请选择" class="select" style="width: 15%" @change="selectProject()" filterable>
                <el-option
                  v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
                </el-option>
              </el-select>
              订单数量:
              <el-input v-model="addForm.num" style="width: 10%"></el-input>
              订单单价:
              <el-input v-model="addForm.unitprice" :change="processData()" style="width: 10%"></el-input>
              折扣率:
              <el-input v-model="addForm.discountrate" style="width: 10%" disabled></el-input>
              市场价:
              <el-input v-model="addForm.shichangjia" style="width: 10%" disabled></el-input>
              <el-button type="text" @click="clickAddSubProject()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in addForm.SubProject" :key="index">
            <li>产品：{{item.projectname}}；数量：{{item.num}}；单价：{{item.unitprice}}；折扣率：{{item.discountrate}}；市场价：{{item.shichangjia}}；
            <el-button type="text" @click="clickDeleteSubProject(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="选择客户">
          <el-select v-model="addForm.customerid" placeholder="请选择" class="select" filterable>
            <!-- <el-option label="新增客户信息" value="-1"></el-option> -->
            <el-option
              v-for="item in CustomerInfoList" :key="item.Id" :label="item.Customername" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="" v-if="addForm.customerid==-1">
          <div class="productdata1">
            <div class="productdata2">
              <el-select v-model="addForm.salesmanid" placeholder="请选择销售员" class="select" filterable>
                <el-option
                  v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
                </el-option>
              </el-select>
              <el-select v-model="addForm.gendanmanid" placeholder="请选择跟单员" class="select" filterable>
                <el-option
                  v-for="item in SalesManList" :key="item.Id" :label="item.Manname" :value="item.Id">
                </el-option>
              </el-select>
              客户名称:
              <el-input v-model="addForm.subcustomername" style="width: 12%"></el-input>
              联系方式:
              <el-input v-model="addForm.sublianxifangshi" style="width: 12%"></el-input>
              银行账号:
              <el-input v-model="addForm.subbankaccount" style="width: 12%"></el-input>
              开户行:
              <el-input v-model="addForm.subbankname" style="width: 12%"></el-input>
              备注:
              <el-input v-model="addForm.subbeizhu" style="width: 12%"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="金额">
          合同总额:
          <el-input v-model="addForm.amountoriginal" disabled :change="processAmount()" style="width: 12%"></el-input>
          返利:
          <el-input v-model="addForm.amountrebates" :change="processAmount()" style="width: 12%"></el-input>
          订单总金额:
          <el-input v-model="addForm.amount" disabled style="width: 12%"></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL" label="收款信息">
          <div class="productdata1">
            <div class="productdata2">
              收款条件:
              <el-input v-model="addFormsub.receiptterms" style="width: 20%"></el-input>
              收款时间:
              <el-date-picker v-model="addFormsub.receipttime" type="date" value-format="yyyy-MM-dd" style="width: 20%"></el-date-picker>
              收款金额:
              <el-input v-model="addFormsub.receiptamount" style="width: 15%"></el-input>
              <el-button type="text" @click="clickAddSubReceipt()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <el-card v-for="item,index in addForm.SubReceipt" :key="index">
            <li>收款条件：{{item.receiptterms}}；收款时间：{{item.receipttime}}；收款金额：{{item.receiptamount}}；
            <el-button type="text" @click="clickDeleteSubReceipt(index)">删除</el-button>
            </li>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm" label="发货日期">
          <el-date-picker v-model="addForm.sendtime" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="发货地址" class="addAdminForm">
          <el-input v-model="addForm.sendaddress"></el-input>
        </el-form-item>
        <el-form-item label="定制文件" class="addAdminForm" v-if="addForm.saletype==2&&addForm.isdingzhi==2">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="dingzhifileTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="addForm.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="apiAddErp6SaleOrder">添加</el-button>
          <el-button type="info" @click="clickReturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- start -->
    <el-tab-pane label="修改销售订单" name="five" disabled="disabled">
      <Erp6SaleOrderEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst"></Erp6SaleOrderEdit>
    </el-tab-pane>
    <!-- end -->

    <el-dialog title="付款信息" :visible.sync="dialogReceiptInfo">
      <el-table :data="ReceiptInfoList">
        <el-table-column property="Receiptterms" label="收款条件" min-width="30%"></el-table-column>
        <el-table-column property="Receipttime" label="收款时间" min-width="30%"></el-table-column>
        <el-table-column property="Receiptamount" label="收款金额"  min-width="30%"></el-table-column>
      </el-table>
    </el-dialog>

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
import Erp6SaleOrderEdit from '@/componentsSubVue/Erp6SaleOrderEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf,
    Erp6SaleOrderEdit
  },
  name: 'MyErp6SaleOrder',
  data () {
    return {
      useriderp: 0,
      activeName: 'first',
      PurchaseCompanyOptions:[],
      ProjectNameList:[],
      SalesManList:[],
      CustomerInfoList:[],
      ReceiptInfoList:[],
      addForm: {
        saletype: '1',
        isdingzhi: '1',
        salecompany: '',
        salesmanid: '',
        customerid: '',
        gendanmanid: '',
        amountoriginal: '0',
        amountrebates: '0',
        amount: '0',
        SubReceipt: [],
        sendtime: '',
        sendaddress: '',
        beizhu: '',
        dingzhifile: '',
        attachment: '',
        //需要新增客户信息时填写的数据
        subcustomername: '',
        sublianxifangshi: '',
        subbankaccount: '',
        subbankname: '',
        subbeizhu: '',
        //产品列表
        SubProject: [],
        //产品列表子元素
        projectcode: '',
        projectname: '',
        projectclassification: '',
        num: '',
        unitprice: '',
        discountrate: '',
        shichangjia: ''
      },
      addFormsub: {
        receiptterms: '',
        receipttime: '',
        receiptamount: ''
      },
      modelShenPi: {
        id: 0,
        opinion: ''
      },
      modelSubmitAgain: {
        id: 0,
        reply: ''
      },
      // 查询
      keywords: {
        orderid: '',
        begintime: '',
        endtime: '',
        customername: '',
        projectcode: '',
        reviewstatus: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogShenPi: false,
      dialogSubmitAgain: false,
      apiShenPiErp6SaleOrderUrl: '',
      SubRule_Erp6SaleOrder_XiaoShou: false,
      SubRule_Erp6SaleOrder_CaiWu: false,
      SubRule_Erp6SaleOrder_FuZong: false,
      SubRule_Erp6SaleOrder_Zong: false,
      dialogReceiptInfo: false
    }
  },
  mounted () {
    this.useriderp = localStorage.getItem('Useriderp')
    this.PurchaseCompanyOptions = Vue.prototype.FunGetPurchaseCompany()
    this.apiGetErp6ProjectNameList()
    this.apiGetErp6SaleBaseSalespersonListAll()
    this.apiGetErp6SaleBaseCustomerInfoListBySalesManId()

    this.apiGetErp6SaleOrderNum()
    this.apiGetErp6SaleOrderList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Erp6SaleOrder_XiaoShou', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6SaleOrder_XiaoShou = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6SaleOrder_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6SaleOrder_CaiWu = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6SaleOrder_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6SaleOrder_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Erp6SaleOrder_Zong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Erp6SaleOrder_Zong = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SaleOrderNum()
      this.apiGetErp6SaleOrderList()
    },
    dingzhifileTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.dingzhifile = url
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.addForm.attachment = url
    },
    clickfile (url) {
      Vue.prototype.FunReviewFileurl(url, this.$router)
    },
    clickedit (row) {
      var that = this
      that.activeName = 'five'
      that.$refs.SubVuefive.LoadData(row,this.ProjectNameList,this.SalesManList)
    },
    processData (){
      var buf = Number(this.addForm.unitprice) / Number(this.addForm.shichangjia)
      this.addForm.discountrate = this.pnum(buf)
    },
    processAmount (){
      var buf = Number(this.addForm.amountoriginal) - Number(this.addForm.amountrebates)
      this.addForm.amount = this.pnum(buf)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clickAddSubProject () {
      if (!Vue.prototype.FunCheckNumber(this.addForm.num)) {
        Vue.prototype.FunAlertMsg('请输入数量')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addForm.unitprice)) {
        Vue.prototype.FunAlertMsg('请输入单价')
        return
      }

      this.addForm.SubProject.push({
        projectcode: this.addForm.projectcode,
        projectname: this.addForm.projectname,
        projectclassification: this.addForm.projectclassification,
        num: parseInt(this.addForm.num),
        unitprice: parseFloat(this.addForm.unitprice),
        discountrate: this.addForm.discountrate,
        shichangjia: this.addForm.shichangjia
      })
      this.countSubProject()
    },
    clickDeleteSubProject (index) {
      var buflist = []
      for (var j = 0, len = this.addForm.SubProject.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.addForm.SubProject[j])
        }
      }
      this.addForm.SubProject = buflist
      this.countSubProject()
    },
    countSubProject(){
      this.addForm.amountoriginal = 0;
      for (var j = 0, len = this.addForm.SubProject.length; j < len; j++) {
        this.addForm.amountoriginal += this.addForm.SubProject[j].num * this.addForm.SubProject[j].unitprice
      }
    },
    clickAddSubReceipt () {
      if (this.addFormsub.receiptterms.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入收款条件')
        return
      }
      if (this.addFormsub.receipttime.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入收款时间')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.addFormsub.receiptamount)) {
        Vue.prototype.FunAlertMsg('请输入收款金额')
        return
      }

      this.addForm.SubReceipt.push({
        receiptterms: this.addFormsub.receiptterms,
        receipttime: this.addFormsub.receipttime,
        receiptamount: parseFloat(this.addFormsub.receiptamount)
      })
    },
    clickDeleteSubReceipt (index) {
      var buflist = []
      for (var j = 0, len = this.addForm.SubReceipt.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.addForm.SubReceipt[j])
        }
      }
      this.addForm.SubReceipt = buflist
    },
    clickReturn () {
      this.activeName = 'first'
    },
    cilckSublist(row){
      this.dialogReceiptInfo = true
      this.ReceiptInfoList = row.Sublist
    },
    ShenHe0 (row) {
      this.dialogSubmitAgain = true
      this.modelSubmitAgain.id = row.Id
      this.modelSubmitAgain.reply = ''
    },
    ShenHe1234 (row, number) {
      this.dialogShenPi = true
      this.modelShenPi.id = row.Id
      this.modelShenPi.opinion = ''
      if (number === 1) {
        this.apiShenPiErp6SaleOrderUrl = Vue.prototype.global.Url_ShenPiErp6SaleOrder1
      }
      if (number === 2) {
        this.apiShenPiErp6SaleOrderUrl = Vue.prototype.global.Url_ShenPiErp6SaleOrder2
      }
      if (number === 3) {
        this.apiShenPiErp6SaleOrderUrl = Vue.prototype.global.Url_ShenPiErp6SaleOrder3
      }
      if (number === 4) {
        this.apiShenPiErp6SaleOrderUrl = Vue.prototype.global.Url_ShenPiErp6SaleOrder4
      }
    },
    ShenHeOK () {
      this.dialogShenPi = false
      this.apiShenPiErp6SaleOrder(1)
    },
    ShenHeNO () {
      this.dialogShenPi = false
      this.apiShenPiErp6SaleOrder(-1)
    },
    SubmitAgain () {
      this.dialogSubmitAgain = false
      this.apiShenPiErp6SaleOrder0()
    },
    clickDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp6SaleOrder(row.Id)
      })
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SaleOrderNum()
      this.apiGetErp6SaleOrderList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SaleOrderList()
    },
    selectProject () {
      this.apiGetErp6SaleBaseProductPriceByProjectcode()
    },
    selectSalesMan () {
      this.apiGetErp6SaleBaseCustomerInfoListBySalesManId()
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源-销售人员
    apiGetErp6SaleBaseSalespersonListAll: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseSalespersonListAll, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.SalesManList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    //为下拉框获取数据源--客户信息
    apiGetErp6SaleBaseCustomerInfoListBySalesManId: function () {
      var that = this
      that.addForm.customerid = ''
      that.CustomerInfoList = []

      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        salesmanid: that.addForm.salesmanid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseCustomerInfoListBySalesManId, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.CustomerInfoList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // 获取产品的市场价
    apiGetErp6SaleBaseProductPriceByProjectcode: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        projectcode: that.addForm.projectcode
      }
      // 加上签名
      // console.log(data)
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseProductPriceByProjectcode, Qs.stringify(data))
        .then(function (response) {
          console.log(response.data)
          if (response.data.Code === 200) {
            that.addForm.shichangjia = response.data.Shichangjia
            that.addForm.projectname = response.data.Projectname
            that.addForm.projectclassification = response.data.Projectclassification
            that.processData()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo
      }
      data = { ...data, ...that.keywords }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            for (var i = 0; i < that.dataList.length; i++) {
              that.dataList[i].Dingzhifiles = []
              if (that.dataList[i].Dingzhifile.length > 1) {
                that.dataList[i].Dingzhifiles = that.dataList[i].Dingzhifile.split('@@@')
              }
              that.dataList[i].Attachments = []
              if (that.dataList[i].Attachment.length > 1) {
                that.dataList[i].Attachments = that.dataList[i].Attachment.split('@@@')
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SaleOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        saletype: that.addForm.saletype,
        isdingzhi: that.addForm.isdingzhi,
        salecompany: that.addForm.salecompany,
        projectcode: that.addForm.projectcode,
        num: that.addForm.num,
        unitprice: that.addForm.unitprice,
        discountrate: that.addForm.discountrate,
        shichangjia: that.addForm.shichangjia,
        salesmanid: that.addForm.salesmanid,
        customerid: that.addForm.customerid,
        gendanmanid: that.addForm.gendanmanid,
        amountoriginal: that.addForm.amountoriginal,
        amountrebates: that.addForm.amountrebates,
        amount: that.addForm.amount,
        subreceipt: JSON.stringify(that.addForm.SubReceipt),
        sendtime: that.addForm.sendtime,
        sendaddress: that.addForm.sendaddress,
        beizhu: that.addForm.beizhu,
        dingzhifile: that.addForm.dingzhifile,
        attachment: that.addForm.attachment,
        subcustomername: that.addForm.subcustomername,
        sublianxifangshi: that.addForm.sublianxifangshi,
        subbankaccount: that.addForm.subbankaccount,
        subbankname: that.addForm.subbankname,
        subbeizhu: that.addForm.subbeizhu,
        subproject: JSON.stringify(that.addForm.SubProject)
      }
      console.log(data)
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SaleOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleOrderNum()
            that.apiGetErp6SaleOrderList()

            // 清空添加
            that.addForm.salecompany = ''
            that.addForm.projectcode = ''
            that.addForm.projectname = ''
            that.addForm.projectclassification = ''
            that.addForm.num = ''
            that.addForm.unitprice = ''
            that.addForm.discountrate = ''
            that.addForm.shichangjia = ''
            that.addForm.salesmanid = ''
            that.addForm.customerid = ''
            that.addForm.gendanmanid = ''
            that.addForm.amountoriginal = '0'
            that.addForm.amountrebates = '0'
            that.addForm.amount = '0'
            that.addForm.SubReceipt = []
            that.addForm.SubProject = []
            that.addForm.sendtime = ''
            that.addForm.sendaddress = ''
            that.addForm.beizhu = ''
            that.addForm.attachment = ''
            that.$refs.MultiImgOrPdf.cleardata()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp6SaleOrder: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp6SaleOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleOrderNum()
            that.apiGetErp6SaleOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6SaleOrder: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelShenPi.id,
        opinion: that.modelShenPi.opinion,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiErp6SaleOrderUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleOrderNum()
            that.apiGetErp6SaleOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiErp6SaleOrder0: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.modelSubmitAgain.id,
        reply: that.modelSubmitAgain.reply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiErp6SaleOrder0, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleOrderNum()
            that.apiGetErp6SaleOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
